module.exports = __webpack_public_path__ + "static/media/mapPionterDark.f6cf5049.png";